import {  createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
// import {API} from '../../axios/instance'

// Async thunk to fetch users
export const fetchUsers = createAsyncThunk('users/fetchUsers', async () => {
    const response = await axios.get('https://jsonplaceholder.typicode.com/users');
    return response.data;
});
